import { RouteConfig } from 'vue-router';

const decision: RouteConfig = {
  path: '/decision',
  component: () => import('../views/decision/decision.vue'),
  meta: {
    title: '数据开发中心'
  },
  children: [
    {
      path: '/decision/rule',
      meta: {
        title: '决策集'
      },
      component: () => import('../views/decision/pages/rule/rule.vue'),
      children: [
        {
          path: '/decision/rule/detail',
          meta: {
            title: '决策集'
          },
          component: () => import('../views/decision/pages/rule/rule-detail.vue')
        },
        {
          path: '/decision/rule/add',
          meta: {
            title: '决策集'
          },
          component: () => import('../views/decision/pages/rule/rule-form.vue')
        },
        {
          path: '/decision/rule/edit',
          meta: {
            title: '决策集'
          },
          component: () => import('../views/decision/pages/rule/rule-form.vue')
        }
      ]
    },
    {
      path: '/decision/indicator',
      meta: {
        title: '指标集'
      },
      component: () => import('../views/decision/pages/indicator/indicator.vue'),
      children: [
        {
          path: '/decision/indicator/detail',
          meta: {
            title: '指标集'
          },
          component: () => import('../views/decision/pages/indicator/indicator-detail.vue')
        },
        {
          path: '/decision/indicator/add',
          meta: {
            title: '指标集'
          },
          component: () => import('../views/decision/pages/indicator/indicator-form.vue')
        },
        {
          path: '/decision/indicator/edit',
          meta: {
            title: '指标集'
          },
          component: () => import('../views/decision/pages/indicator/indicator-form.vue')
        }
      ]
    },
    {
      path: '/decision/subject',
      meta: {
        title: '主题表'
      },
      component: () => import('../views/decision/pages/subject/subject.vue'),
      children: [
        {
          path: '/decision/subject/detail',
          meta: {
            title: '主题表'
          },
          component: () => import('../views/decision/pages/subject/subject-detail.vue')
        },
        {
          path: '/decision/subject/add',
          meta: {
            title: '主题表'
          },
          component: () => import('../views/decision/pages/subject/subject-form.vue')
        },
        {
          path: '/decision/subject/edit',
          meta: {
            title: '主题表'
          },
          component: () => import('../views/decision/pages/subject/subject-form.vue')
        }
      ]
    },
    {
      path: '/decision/dict',
      meta: {
        title: '字典集'
      },
      component: () => import('../views/decision/pages/dict/dict.vue'),
      children: [
        {
          path: '/decision/dict/detail',
          meta: {
            title: '字典集'
          },
          component: () => import('../views/decision/pages/dict/dict-detail.vue')
        },
        {
          path: '/decision/dict/add',
          meta: {
            title: '字典集'
          },
          component: () => import('../views/decision/pages/dict/dict-add.vue')
        },
        {
          path: '/decision/dict/edit',
          meta: {
            title: '字典集'
          },
          component: () => import('../views/decision/pages/dict/dict-edit.vue')
        }
      ]
    },
    {
      path: '/decision/params',
      meta: {
        title: '参数集'
      },
      component: () => import('../views/decision/pages/params/params.vue'),
      children: [
        {
          path: '/decision/params/detail',
          meta: {
            title: '参数集'
          },
          component: () => import('../views/decision/pages/params/params-detail.vue')
        },
        {
          path: '/decision/params/add',
          meta: {
            title: '参数集'
          },
          component: () => import('../views/decision/pages/params/params-add.vue')
        },
        {
          path: '/decision/params/edit',
          meta: {
            title: '参数集'
          },
          component: () => import('../views/decision/pages/params/params-edit.vue')
        }
      ]
    },
    {
      path: '/decision/dimension',
      meta: {
        title: '维度表'
      },
      component: () => import('../views/decision/pages/dimension/dimension.vue'),
      children: [
        {
          path: '/decision/dimension/detail',
          meta: {
            title: '维度表'
          },
          component: () => import('../views/decision/pages/dimension/dimension-detail.vue')
        },
        {
          path: '/decision/dimension/add',
          meta: {
            title: '维度表'
          },
          component: () => import('../views/decision/pages/dimension/dimension-form.vue')
        },
        {
          path: '/decision/dimension/edit',
          meta: {
            title: '维度表'
          },
          component: () => import('../views/decision/pages/dimension/dimension-form.vue')
        }
      ]
    },
    {
      path: '/decision/trail',
      meta: {
        title: '陪跑记录'
      },
      component: () => import('../views/decision/pages/trail/trail.vue')
    },
    {
      path: '/decision/trailAlert',
      meta: {
        title: '陪跑预警查询'
      },
      component: () => import('../views/decision/pages/trail/trail-alert.vue')
    }
  ]
};

export default decision;
